import styled, { css } from 'styled-components'

import { Divider } from '@reveni-io/reveni-ui'

import { drawerMobileBreakpoint } from './constants'

const fullDrawerWidth = css`
  margin-left: -${props => props.theme.spacing.sp32};
  margin-right: -${props => props.theme.spacing.sp32};

  @media (max-width: ${drawerMobileBreakpoint - 1}px) {
    margin-left: -${props => props.theme.spacing.sp16};
    margin-right: -${props => props.theme.spacing.sp16};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Header = styled.div`
  display: flex;
  justify-content: center;
`

export const FullWidthDivider = styled(Divider)`
  width: auto;
  ${fullDrawerWidth}
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp24} ${props => props.theme.spacing.sp32};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  ${fullDrawerWidth}

  @media (max-width: ${drawerMobileBreakpoint - 1}px) {
    padding: ${props => props.theme.spacing.sp24} ${props => props.theme.spacing.sp16};
  }
`

export const FooterActions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
